import { render, staticRenderFns } from "./add-ad-product-target.vue?vue&type=template&id=67f84038&scoped=true&"
import script from "./add-ad-product-target.vue?vue&type=script&lang=js&"
export * from "./add-ad-product-target.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-product-target.vue?vue&type=style&index=0&id=67f84038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f84038",
  null
  
)

export default component.exports